import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const uploadSingleFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-file-uploader/uploads';
    const pathInternal = '/api/uploads';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadSingleFile.paramsOrder = [{ type: 'formData' }];
export const initializeUpload = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.request === undefined) {
        throw new Error('Missing required body: request');
    }
    const path = '/api/ws-file-uploader/uploads/multipart';
    const pathInternal = '/api/uploads/multipart';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.request !== undefined) {
        body = params.request;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
initializeUpload.paramsOrder = [{ type: 'body', paramName: 'request' }];
export const getChunkUploadUrl = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.uploadId === undefined) {
        throw new Error('Missing required parameter: uploadId');
    }
    if (params.chunkId === undefined) {
        throw new Error('Missing required parameter: chunkId');
    }
    if (params.key === undefined) {
        throw new Error('Missing required parameter: key');
    }
    const path = '/api/ws-file-uploader/uploads/multipart/{uploadId}/url'.replace('{uploadId}', params.uploadId?.toString());
    const pathInternal = '/api/uploads/multipart/{uploadId}/url'.replace('{uploadId}', params.uploadId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.chunkId !== undefined) {
        urlParams.append('chunkId', params.chunkId.toString());
    }
    if (params.key !== undefined) {
        urlParams.append('key', params.key.toString());
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getChunkUploadUrl.paramsOrder = [{ type: 'parameters' }];
export const completeUpload = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.uploadId === undefined) {
        throw new Error('Missing required parameter: uploadId');
    }
    if (params.completeMultipartUploadRequest === undefined) {
        throw new Error('Missing required body: completeMultipartUploadRequest');
    }
    const path = '/api/ws-file-uploader/uploads/multipart/{uploadId}/complete'.replace('{uploadId}', params.uploadId?.toString());
    const pathInternal = '/api/uploads/multipart/{uploadId}/complete'.replace('{uploadId}', params.uploadId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.completeMultipartUploadRequest !== undefined) {
        body = params.completeMultipartUploadRequest;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
completeUpload.paramsOrder = [
    { type: 'body', paramName: 'completeMultipartUploadRequest' },
    { type: 'parameters' },
];
export const abortUpload = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.uploadId === undefined) {
        throw new Error('Missing required parameter: uploadId');
    }
    if (params.fileKey === undefined) {
        throw new Error('Missing required parameter: fileKey');
    }
    const path = '/api/ws-file-uploader/uploads/multipart/{uploadId}/abort'.replace('{uploadId}', params.uploadId?.toString());
    const pathInternal = '/api/uploads/multipart/{uploadId}/abort'.replace('{uploadId}', params.uploadId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.fileKey !== undefined) {
        urlParams.append('fileKey', params.fileKey.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
abortUpload.paramsOrder = [{ type: 'parameters' }];
export const uploadSingleFileFromUrl = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.uploadUrlRequest === undefined) {
        throw new Error('Missing required body: uploadUrlRequest');
    }
    const path = '/api/ws-file-uploader/uploads/url';
    const pathInternal = '/api/uploads/url';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.uploadUrlRequest !== undefined) {
        body = params.uploadUrlRequest;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
uploadSingleFileFromUrl.paramsOrder = [{ type: 'body', paramName: 'uploadUrlRequest' }];
export const downloadFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    const path = '/api/ws-file-uploader/downloads/{fileId}'.replace('{fileId}', params.fileId?.toString());
    const pathInternal = '/api/downloads/{fileId}'.replace('{fileId}', params.fileId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: {
            200: 'blob',
            204: 'blob',
        },
        requestType: 'json',
    });
};
downloadFile.paramsOrder = [{ type: 'parameters' }];
export const generateUri = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    const path = '/api/ws-file-uploader/downloads/{fileId}/uri'.replace('{fileId}', params.fileId?.toString());
    const pathInternal = '/api/downloads/{fileId}/uri'.replace('{fileId}', params.fileId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: {
            200: 'json',
            204: 'json',
        },
        requestType: 'json',
    });
};
generateUri.paramsOrder = [{ type: 'parameters' }];
export const checkFileExists = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    const path = '/api/ws-file-uploader/file/{fileId}/exists'.replace('{fileId}', params.fileId?.toString());
    const pathInternal = '/api/file/{fileId}/exists'.replace('{fileId}', params.fileId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkFileExists.paramsOrder = [{ type: 'parameters' }];
export const getFilesInfo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-file-uploader/files-info';
    const pathInternal = '/api/files-info';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFilesInfo.paramsOrder = [{ type: 'parameters' }];
export const renameFileInfo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    const path = '/api/ws-file-uploader/files-info/{fileId}'.replace('{fileId}', params.fileId?.toString());
    const pathInternal = '/api/files-info/{fileId}'.replace('{fileId}', params.fileId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.name !== undefined) {
        urlParams.append('name', params.name.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
renameFileInfo.paramsOrder = [{ type: 'parameters' }];
export const deleteFileInfo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    const path = '/api/ws-file-uploader/files-info/{fileId}'.replace('{fileId}', params.fileId?.toString());
    const pathInternal = '/api/files-info/{fileId}'.replace('{fileId}', params.fileId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deleteFileInfo.paramsOrder = [{ type: 'parameters' }];
export const getFilesInfoByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.fileIds === undefined) {
        throw new Error('Missing required body: fileIds');
    }
    const path = '/api/ws-file-uploader/files-info/batch';
    const pathInternal = '/api/files-info/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.fileIds !== undefined) {
        body = params.fileIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFilesInfoByIds.paramsOrder = [{ type: 'body', paramName: 'fileIds' }];
export * from './types';
export * from './constants';
